import CoinStack from '@/assets/icons/CoinStack.svg';
import Gift from '@/assets/icons/Gift.svg';
import Tag from '@/assets/icons/Tag.svg';
import type { PaymentAmounts } from '@/types';
import { testIsFree } from '@/utils/testIsFree';
import { LineItem } from './LineItem';
import * as Styled from './Amounts.styled';

interface AmountsProps {
  amounts: PaymentAmounts | null;
}

const lineItemProps = {
  discount: { flipIcon: true, icon: <Tag />, label: 'Discount' },
  giftcard: { icon: <Gift />, label: 'Gift card' },
  loyaltycard: { icon: <CoinStack />, label: 'Loyalty card' },
  shipping: { label: 'Delivery' },
  subtotal: { label: 'Subtotal' },
};

export const Amounts = ({ amounts }: AmountsProps) => {
  const { discount, giftCard, loyaltyCard, shipping, subtotal, tax, total } =
    amounts ?? {};
  return (
    <>
      <Styled.Ledger>
        {subtotal ? (
          <LineItem {...lineItemProps.subtotal} value={subtotal} />
        ) : null}
        {shipping ? (
          <LineItem
            {...lineItemProps.shipping}
            value={testIsFree(shipping) ? 'Free' : shipping}
          />
        ) : null}
        {(giftCard?.length ?? 0) > 0
          ? giftCard
              ?.filter(x => x.isApplied)
              .map(({ applied, cardNumber }) => (
                <LineItem
                  key={cardNumber}
                  {...lineItemProps.giftcard}
                  extraData={cardNumber}
                  value={`-${applied}`}
                />
              ))
          : null}
        {loyaltyCard ? (
          <LineItem {...lineItemProps.loyaltycard} value={`-${loyaltyCard}`} />
        ) : null}
        {discount ? (
          <LineItem {...lineItemProps.discount} value={`-${discount}`} />
        ) : null}
        {total ? <LineItem isTotal={true} label="Total" value={total} /> : null}
      </Styled.Ledger>
      <Styled.Text>Including {tax} in taxes</Styled.Text>
    </>
  );
};
